module.exports = __webpack_public_path__ + "img/isometric.9d6b64fc.png";